export default __webpack_public_path__ + "static/media/LEVEL17.dd486ef0.png";